/** @format */

import { Link } from 'gatsby-plugin-intl';
import styled from 'styled-components';

export const Card = styled.div<{ $hideTopRadius?: boolean }>`
  width: 100%;
  height: auto;
  background-color: var(--white, #fff);

  border-radius: 0.25rem;
  border-top-left-radius: ${({ $hideTopRadius }) => ($hideTopRadius ? '0' : '0.25rem')};
  border-top-right-radius: ${({ $hideTopRadius }) => ($hideTopRadius ? '0' : '0.25rem')};
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  box-shadow: 0px 1px 3px 0px rgba(16, 24, 40, 0.1), 0px 1px 2px 0px rgba(16, 24, 40, 0.06);
  isolation: isolate;
`;

export const CardLink = styled(Link)`
  width: 100%;
  height: auto;
  display: block;
  text-decoration: none;
  color: inherit;
  background-color: transparent;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  cursor: pointer;
`;

export const CardInfo = styled.div`
  padding: 1rem;
  width: 100%;
`;
export const Title = styled.h2<{ $fullWidth?: boolean }>`
  --clamped-width: clamp(18.5rem, 17.5192rem + 4.359vw, 22.75rem);

  max-width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'var(--clamped-width)')};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: var(--gray-900, #101828);
  font-family: ${({ theme }) => theme.font.body};
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5rem;
  margin: 0;
  margin-top: 0;
  margin-bottom: 0.5rem;

  @media screen and (max-width: 480px) {
    max-width: 16.5rem;
  }
`;

export const Divider = styled.div`
  height: 0.0625rem;
  align-self: stretch;
  background: var(--gray-200, #eaecf0);
  margin-block: 1rem;
`;
export const BottomDetails = styled.div<{ isPopup?: boolean }>`
  position: relative;
  min-height: ${({ isPopup }) => (isPopup ? '0' : '3.13rem')};
  display: flex;
  gap: 0.5rem;
  justify-content: space-between;
  align-items: center;
`;
